import { render, staticRenderFns } from "./MakeTab1.vue?vue&type=template&id=7d1894dd&scoped=true&lang=pug&"
import script from "./MakeTab1.vue?vue&type=script&lang=js&"
export * from "./MakeTab1.vue?vue&type=script&lang=js&"
import style0 from "./MakeTab1.vue?vue&type=style&index=0&id=7d1894dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1894dd",
  null
  
)

export default component.exports